/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ColorPicker from 'mb-react-color-picker';
import CloseIcon from '@material-ui/icons/Close';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import Settings from '../../../images/setting';
import '../../../styles/connectorDialog.scss';


function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'} handle=".MuiTypography-h6">
      <Paper {...props} />
    </Draggable>
  );
}

export class ConnectorDialog extends Component {
  state = { connectorType: 'solid', color: '' };

  componentDidMount() {
    const { connectorSettings } = this.props;
    const { connectorType = 'solid', color = 'black', size = 5 } = connectorSettings || {};
    this.setState({ connectorType, color, size });
    this.handleColorOnChange(color);
    this.handleSizeChange(size);
  }

  handleChange = (e) => {
    this.setState({ connectorType: e.target.value, color: 'black', size: '5' });
  }

  handleColorConfirm = (color) => {
    this.setState({ color });
  }

  handleColorOnChange = (color) => {
    this.setState({ color });
  }

  handleSizeChange = (size) => {
    this.setState({ size: Number(size) });
  }

  onClose = (save) => {
    const { close } = this.props;
    const { connectorType, color, size } = this.state;
    const data = { connectorType, color, size, dash: connectorType === 'dotted' ? { animation: true } : connectorType !== 'solid' ? true : false }
    close(save ? data : null);
  }

  reset = () => {
    this.setState({ connectorType: 'solid', color: 'black', size: 5 });
  }

  render() {
    const { open } = this.props;
    const { connectorType, color, size } = this.state;
    const style = { borderColor: color, borderWidth: `${size}px` };
    return (
      <Dialog
        onClose={() => { this.onClose(); }}
        aria-labelledby="simple-dialog-title"
        open={open}
        PaperComponent={PaperComponent}
        disableBackdropClick
      >
        <DialogTitle id="simple-dialog-title">
          <div className="settingText">
            <Settings className="settings" />
            Connector Settings
          </div>
          <CloseIcon className="close" onClick={() => { this.onClose(); }} />
        </DialogTitle>
        <div className="content">
          <div className="connector-types">
            <RadioGroup
              aria-label="gender"
              name="gender2"
              value={connectorType}
              onChange={this.handleChange}
              className="type-wrapper"
            >
              <FormControlLabel
                value="solid"
                control={<Radio color="primary" />}
                label={(
                  <div
                    className="normal"
                    id="connectorTypeDummy"
                    style={connectorType === 'solid' ? style : {}}
                  />
                )}
              />
              <FormControlLabel
                value="dashed"
                control={<Radio color="primary" />}
                label={(
                  <div
                    className="dashed"
                    id="connectorTypeDummy"
                    style={connectorType === 'dashed' ? style : {}}
                  />
                )}
              />
              <FormControlLabel
                value="dotted"
                control={<Radio color="primary" />}
                label={(
                  <div
                    className="dotted"
                    id="connectorTypeDummy"
                    style={connectorType === 'dotted' ? style : {}}
                  />
                )}
              />
            </RadioGroup>

          </div>
          <div className="color-wrapper">
            <ColorPicker
              color={color}
              onConfirm={this.handleColorConfirm}
              onChange={this.handleColorOnChange}
            />
            <div>
              <label htmlFor="size">Size</label>
              <input
                type="number"
                className="size-input"
                value={size}
                onChange={(e) => { this.handleSizeChange(e.target.value); }}
                min={5}
                max={10}
                id="size"
              />
            </div>
          </div>
          <div className="button-wrapper">
            <button
              onClick={this.reset}
              type="button"
              className="secondaryButton"
            >
              Reset
            </button>
            <button
              onClick={() => { this.onClose(true); }}
              type="button"
            >
              Save
            </button>
          </div>
        </div>
      </Dialog>
    );
  }
}

ConnectorDialog.propTypes = {
  connectorSettings: PropTypes.instanceOf(Object).isRequired,
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
